enum Statuses {
  Initial = 'Initial',
  Success = 'Success',
  Error = 'Error'
};

export default Statuses;
